var render = function render(){var _vm=this,_c=_vm._self._c;return _c('packing',{ref:"packing",attrs:{"device":_vm.device,"query-param":_vm.queryParam}})
}
var staticRenderFns = []

export { render, staticRenderFns }